import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';

type NumericInputProps = {
    label: string;
    onChange: (v: number) => void;
    value: number;
};

export const NumericInput = (props: NumericInputProps) => {

    const { label, onChange, value } = props;

    return (
        <GMetrixInput
            label={label}
            min={0}
            onChange={e => onChange(Number((e.target as HTMLInputElement).value))}
            type="number"
            value={value === 0 ? '' : value}
        />
    );

};
